import React from 'react';
import { calendarPickerClasses } from '@mui/x-date-pickers';
import { Button, Form } from 'react-bootstrap';
import LoadSheetModal from '../SamedayDispatch/LoadSheetModal';
import TextField from '../../designSystem/TextField';
import FlipOrdersDialog from './FlipOrdersDialog';
import { toast } from 'react-toastify';

export const tripBoardColumns = (props, options = { excludeFields: [], accessorialCodes: [], orderClassification: null }) => {

    const codes = options?.accessorialCodes?.data?.map((code) => {
        return {
            field: code?.accessorialCode,
            headerName: code?.accessorialCode,
            width: 80,
            editable: false,
        }
    })

    const allColumns = [
        {
            field: 'Action', headerName: 'Action', width: 90,
            renderCell: (data) => {
                const onClick = async (e) => {
                    e.stopPropagation();
                    const result = await props.getDetails({ divisionId: props.divisionIdRef.current, orderId: data.row.id })
                    if (result.data.statusCode === 200) {
                        props.setSelectedOrder(result.data?.data);
                    }
                };
                return (
                    <Button fullWidth onClick={onClick}>Details</Button>
                )
            }
        },
        {
            field: 'removeDriver',
            headerName: 'Remove Driver',
            width: 120,
            editable: false,
            renderCell: (data) => {
                return (
                    <Button style={{ width: '50%' }} onClick={() => {
                        if (!data?.row?.PDriv && !data?.row?.DDrive && !data?.row?.lineHauler && !data?.row?.dxDock && !data?.row?.pxDock) {
                            toast.error('No drivers assigned to this order.', { position: 'top-center' });
                            return;
                        }
                        props.setRemoveDriverPopup(true);
                        props.setRemoveID(data.row.id);
                    }}>X</Button>
                )
            }
        },
        ...(props.boardType !== "OPEN_BOARD" & (props.classificationRadio === 1 || props.classificationRadio === 2) ? [{
            field: 'flip',
            headerName: 'Flip Order Status',
            width: 140,
            editable: false,
            renderCell: (data) => (
                <FlipOrdersDialog
                    getTripOrdersClassification={props.getTripOrdersClassification}
                    selectedTrip={props.selectedTrip}
                    divisionIdRef={props.divisionIdRef}
                    orderData={data}
                    orderClassification={options.orderClassification}
                />
            )
        }] : []),
        {
            field: 'orderNumber',
            headerName: 'Order Number',
            width: 120,
            editable: false,
        },
        {
            field: 'readyTime',
            headerName: 'Ready Date & Time',
            type: calendarPickerClasses,
            width: 200,
            editable: false,
        },
        {
            field: 'customerName',
            headerName: 'Customer',
            width: 120,
            editable: false,
        },
        {
            field: 'service',
            headerName: 'Service',
            width: 120,
            editable: false,
        },
        {
            field: 'Vehicle',
            headerName: 'Vehicle',
            width: 150,
            editable: false,
        },
        {
            field: 'tripNo',
            headerName: 'Trip Number',
            width: 120,
            editable: false,
        },
        {
            field: 'pickupCity',
            headerName: 'Pickup City',
            width: 120,
            editable: false,
        },
        {
            field: 'pickupProvince',
            headerName: 'Pickup Province',
            width: 120,
            editable: false,
        },
        {
            field: 'PDriv',
            headerName: 'P-Driver',
            width: 80,
            editable: false,
        },
        {
            field: 'isPickedup',
            headerName: 'P',
            width: 40,
            editable: false,
            renderCell: (data) => {
                return (
                    <Form.Check
                        onChange={(e) => {
                            e.target.checked = !e.target.checked;
                            if (!data?.row?.PDriv) {
                                toast.error('Please assign a driver to the order before picking up.', { position: 'top-center' });
                                return;
                            }
                            const checked = data?.row?.isPickedup || false;
                            if (checked) {
                                props.setShowRemoveDriverCheckbox(true);
                            }
                            else {
                                props.setShowPickupModal(true);
                            }
                            props.setOrderStatusCode("P");
                            props.setAssignDriverCheckbox(!checked);
                        }}
                        aria-label="Checkbox for following text input" checked={data?.row?.isPickedup} />
                )
            }
        },
        {
            field: 'pxDock',
            headerName: 'PX',
            width: 120,
            editable: false,
        },
        {
            field: 'isArrivedAtPxDock',
            headerName: 'Arrived to PX',
            width: 110,
            editable: false,
            renderCell: (data) => {
                return (
                    <Form.Check aria-label="Checkbox for following text input" checked={data?.row?.isArrivedAtPxDock}
                        onChange={(e) => {
                            e.target.checked = !e.target.checked;
                            if (!data?.row?.pxDock) {
                                toast.error('Please assign a driver to the order before picking up.', { position: 'top-center' });
                                return;
                            }
                            const checked = data?.row?.isArrivedAtPxDock || false;
                            if (checked) {
                                props.setShowRemoveDriverCheckbox(true);
                            }
                            else {
                                props.setShowPickupModal(true);
                            }
                            props.setOrderStatusCode("PX");
                            props.setAssignDriverCheckbox(!checked);
                        }}
                    />
                )
            }
        },
        {
            field: 'dropoffCity',
            headerName: 'Receiving City',
            width: 120,
            editable: false,
        },
        {
            field: 'dropoffProvince',
            headerName: 'Receiving Province',
            width: 120,
            editable: false,
        },
        {
            field: 'lineHauler',
            headerName: 'Ln-Hl',
            width: 80,
            editable: false,
        },
        {
            field: 'dxDock',
            headerName: 'DX',
            width: 140,
            editable: false,
        },
        {
            field: 'isArrivedAtDxDock',
            headerName: 'Arrived to DX',
            width: 110,
            editable: false,
            renderCell: (data) => {
                return (
                    <Form.Check aria-label="Checkbox for following text input" checked={data?.row?.isArrivedAtDxDock}
                        onChange={(e) => {
                            e.target.checked = !e.target.checked;
                            if (!data?.row?.dxDock) {
                                toast.error('Please assign a driver to the order before picking up.', { position: 'top-center' });
                                return;
                            }
                            const checked = data?.row?.isArrivedAtDxDock || false;
                            if (checked) {
                                props.setShowRemoveDriverCheckbox(true);
                            }
                            else {
                                props.setShowPickupModal(true);
                            }
                            props.setOrderStatusCode("DX");
                            props.setAssignDriverCheckbox(!checked);
                        }}
                    />
                )
            }
        },
        {
            field: 'DDrive',
            headerName: 'D-Driver',
            width: 80,
            editable: false,
        },
        {
            field: 'isOutForDelivery',
            headerName: 'OD',
            width: 40,
            editable: false,
            renderCell: (data) => {
                return (
                    <Form.Check aria-label="Checkbox for following text input" checked={data?.row?.isOutForDelivery}
                        onChange={(e) => {
                            e.target.checked = !e.target.checked;
                            if (!data?.row?.DDrive) {
                                toast.error('Please assign a delivery driver to the order', { position: 'top-center' });
                                return;
                            }
                            const checked = data?.row?.isOutForDelivery || false;
                            if (checked) {
                                props.setShowRemoveDriverCheckbox(true);
                            }
                            else {
                                props.setShowPickupModal(true);
                            }
                            props.setOrderStatusCode("OD");
                            props.setAssignDriverCheckbox(!checked);
                        }}
                    />
                )
            }
        },
        {
            field: 'isDelivered',
            headerName: 'D',
            width: 40,
            editable: false,
            renderCell: (data) => {
                return (
                    <Form.Check aria-label="Checkbox for following text input" checked={data?.row?.isDelivered}
                        onChange={(e) => {
                            e.target.checked = !e.target.checked;
                            if (!data?.row?.DDrive) {
                                toast.error('Please assign a delivery driver to the order', { position: 'top-center' });
                                return;
                            }
                            const checked = data?.row?.isDelivered || false;
                            if (checked) {
                                props.setShowRemoveDriverCheckbox(true);
                            }
                            else {
                                props.setShowPickupModal(true);
                            }
                            props.setOrderStatusCode("D");
                            props.setAssignDriverCheckbox(!checked);
                        }} />
                )
            }
        },
        {
            field: 'Pcs',
            headerName: 'Pcs',
            width: 40,
            editable: false,
        },

        {
            field: 'Wgt',
            headerName: 'Weight',
            width: 90,
            editable: false,
        },
        {
            field: 'LoadSheet',
            headerName: 'L-Sheet',
            width: 120,
            editable: false,
            renderCell: (data) => {
                return (<LoadSheetModal />);
            }
        },
        {
            field: 'dropNo',
            headerName: 'Drop No',
            width: 80,
            editable: false,
            renderCell: (data) => {
                return (
                    <TextField size="sm" />
                )
            }
        },
        ...codes || [],
        {
            field: '309',
            headerName: '309',
            width: 40,
            editable: false,
            renderCell: (data) => {
                return (
                    <Form.Check aria-label="Checkbox for following text input" checked={data?.row?.[309]} />
                )
            }
        },
        {
            field: '358',
            headerName: '358',
            width: 40,
            editable: false,
            renderCell: (data) => {
                return (
                    <Form.Check aria-label="Checkbox for following text input" checked={data?.row?.[358]} />
                )
            }
        },
        {
            field: '997',
            headerName: '997',
            width: 40,
            editable: false,
            renderCell: (data) => {
                return (
                    <Form.Check aria-label="Checkbox for following text input" checked={data?.row?.[997]} />
                )
            }
        },
    ];

    const removeTripColumn = {
        field: 'removeTrip',
        headerName: 'Remove Trip',
        width: 120,
        editable: false,
        renderCell: (data) => {
            return (
                <Button style={{ width: '50%' }} onClick={() => {
                    if (data?.row.isDelivered) {
                        toast.error('Cannot remove trip, order is already delivered.', { position: 'top-center' });
                        return;
                    }
                    props.setShowRemoveTrip(true);
                    props.setOrderID(data.row.id);
                    props.setOrderNumber(data.row.OrderNumber);
                }}>X</Button>
            )
        }
    }

    if (props.boardType === "TRIP_BOARD") {
        allColumns.splice(1, 0, removeTripColumn);
    }

    const filteredColumns = allColumns.filter(
        (col) => !options?.excludeFields?.includes(col.field)
    );

    return filteredColumns;
};


export const tripBoardRows = (orders) => {
    return orders?.map((order) => ({
        id: order?.orderId || order?.orderID,
        Action: 1,
        readyTime: order?.readyDate
            ? new Date(order?.readyDate).toLocaleString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            })
            : '',
        isOutForDelivery: order?.isOutForDelivery,
        dxDock: order?.dxDock,
        feet: order?.feet,
        pxDock: order?.pxDock,
        dropNo: order?.dropNo,
        isArrivedAtPxDock: order?.isArrivedAtPxDock,
        isArrivedAtDxDock: order?.isArrivedAtDxDock,
        lineHauler: order?.lineHauler,
        customerName: order?.customer,
        tripNo: order?.tripNo,
        isPickedup: order?.isPickedup,
        isDelivered: order?.isDelivered,
        service: order?.service,
        orderNumber: order?.orderNumber,
        pickupCity: order?.pickupCity,
        pickupProvince: order?.pickupProvince,
        Map: order?.map,
        ...order?.accessorialCodesForOrder,
        Vehicle: order?.vehicle,
        Service: order?.service,
        PDrive: order?.pDrive,
        PDriv: order?.pickUpDriver,
        DDrive: order?.deliveryDriver,
        dropoffCity: order?.dropoffCity,
        dropoffProvince: order?.dropoffProvince,
        DMap: order?.dMap,
        DA: order?.dA,
        TC: order?.tc,
        HV: order?.hv,
        RS: order?.rs,
        DTG: order?.dtg,
        HZ: order?.hz,
        Pcs: order?.pcs,
        Wgt: order?.weight,
        OrderNumber: order?.orderNumber,
        Expirytime: order?.expiryTime,
    }
    ))
};
